import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyAiPackageById, verifyPackageById } from "../../ApiController/ApiService"; 
// import check from "../../assets/check.svg"; // Consider using a glowing AI-themed icon
import Swal from "sweetalert2";
import { Check } from "lucide-react";

const ThanksAiPackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState(null);

useEffect(() => {
  if (!id) {
    setError("AI Package Token is missing");
    Swal.fire({
      icon: "error",
      title: "Access Denied",
      text: "We couldn't find your package ID. Please contact support.",
      confirmButtonColor: "#8B5CF6",
    });
    return;
  }

  const verifyAiPackage = async () => {
    setIsVerifying(true);
    setError(null);

    const result = await verifyAiPackageById(id, 'Paid');

    if (result.success) {
      Swal.fire({
        icon: "success",
        title: "AI Power Activated!",
        text: "Your advanced AI tools are now ready for use.",
        confirmButtonColor: "#8B5CF6",
        timer: 2500,
        showConfirmButton: false,
      }).then(() => {
        navigate("/dashboard");
      });
    } else {
      setError(result.message);
      Swal.fire({
        icon: "error",
        title: "Synchronization Failed",
        text: result.message,
        confirmButtonColor: "#8B5CF6",
      });
    }

    setIsVerifying(false);
  };

  verifyAiPackage();
}, [id, navigate]);

  return (
    <div className="min-h-screen bg-[#050510] flex items-center justify-center p-4">
      {/* Glow Effect Background */}
      <div className="absolute w-[300px] h-[300px] bg-[#6F1AFF] rounded-full blur-[120px] opacity-20"></div>

      <div
        className="relative bg-[#0F0D2E]/80 border border-white/10 p-10 rounded-[2rem] w-full max-w-lg text-center shadow-2xl"
        style={{ backdropFilter: "blur(50px)" }}
      >
        {/* Header Section */}
        <h2 className="text-[32px] md:text-[40px] font-bold text-white leading-tight font-sans">
          AI Package <br />
          <span className="text-[#8B5CF6] drop-shadow-[0_0_15px_rgba(111,26,255,0.5)]">
            Activated Successfully
          </span>
        </h2>

        <p className="text-gray-400 mt-4 text-base">
          Welcome to the future. Your AI workspace has been upgraded with 
          new capabilities and enhanced processing power.
        </p>

        {/* Visual Element */}
        <div className="flex justify-center my-10 relative">
          <div className="absolute inset-0 bg-[#6F1AFF] rounded-full blur-3xl opacity-20 animate-pulse"></div>
        <Check size={18}/>
        </div>

        {/* Status Section */}
        <div className="space-y-3">
          {isVerifying && (
            <div className="flex items-center justify-center gap-3">
              <div className="w-4 h-4 border-2 border-[#6F1AFF] border-t-transparent rounded-full animate-spin"></div>
              <p className="text-purple-300 text-sm font-medium tracking-wide">
                INITIALIZING AI MODULES...
              </p>
            </div>
          )}
          
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 p-3 rounded-lg">
              <p className="text-red-400 text-sm">{error}</p>
            </div>
          )}
        </div>

        {/* Footer info */}
        {!isVerifying && !error && (
          <p className="text-xs text-gray-500 uppercase tracking-[0.2em] mt-6">
            Redirecting to  Dashboard
          </p>
        )}
      </div>
    </div>
  );
};

export default ThanksAiPackage;